//Models
PJQ.helpers.users = {
	sendPasswordReset: function (username, callback) {
		let result = {
			success: false,
			error: null
		};
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'requestpasswordreset'
				}
			], [
				{
					parameter: 'masterUserId',
					value: PJQ.app.session.get('masterUserId')
				},
				{
					parameter:'username',
					value: username
				}
			])
		}).post().done(_.bind(function (data) {
			result.success = data.success;
			if (!result.success) {
				result.error = PJQ.Errors.auth[data.error];
			}

			if (typeof callback === 'function') {
				callback(result);
			}
		}, this)).fail(_.bind(function (xhr, err, result) {
			result.error = PJQ.Errors.auth.CUSTOMER_SERVICE;
			if (typeof callback === 'function') {
				callback(result);
			}

			new PJQ.logging.Debug(PJQ.logging.LoggingActions.AUTH_RESET_PASSWORD, {
				error: err,
				result: result
			});
		}, this));
	}
};

PJQ.models.users = {};

PJQ.models.users.User = PJQ.models.contacts.Contact.extend({
	idAttribute: 'userId',
	defaults: {
		type: 'user'
	},
	endpoint: function () {
		let params = [];
		if (this.isNew()) {
			params.push(...[{
				parameter: 'username',
				value: this.get('username')
			}, {
				parameter: 'password',
				value: this.get('password')
			}]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users',
				value: this.id < 0 ? -this.id : this.id
			}
		], params)
	},
	parse: function (model) {
		if (model != null) {
			if (PJQ.app.session != null) {
				if (model.userTypeId != null) {
					this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
				}

				if (this.userType === null) {
					this.userType = PJQ.app.session.userTypes.getDefault(true);
				}
			}

			if (this.groups == null) {
				this.groups = new PJQ.collections.groups.Groups(model.groups, {
					groupLevels: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
				});
			} else {
				//Override for groups being returned in a nested object
				//This is some old api stuff that will soon be deprecated
				//We will remove this when that happens
				if (model.groups != null) {
					model.groups = model.groups;
				}
				this.groups.reset(_.size(model.groups) > 0 ? model.groups : null);
				this.groups.options.groupLevels = PJQ.app.session ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS) : 1;
			}

			if(model.companyId == null){
				model.companyId = 0;
			}
		}
		else {
			this.userType = PJQ.app.session != null ? PJQ.app.session.userTypes.getDefault(true) : null;
		}
		return model;
	},
	fetchRFISettings: function (callback) {
		if (this.rfiSettings == null) {
			this.rfiSettings = new PJQ.models.rfi.Settings();
			this.rfiSettings.fetch({
				success: _.bind(function () {
					callback(this.rfiSettings);
				}, this)
			});
		}
		else {
			callback(this.rfiSettings);
		}
	},
	sendPasswordReset: function (callback) {
		PJQ.helpers.users.sendPasswordReset(this.get('username'), function (result) {
			if (typeof callback === 'function') {
				callback(result);
			}
		});
	},
	unlock: function (callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.id
				},
				{
					endpoint: 'unlock'
				}
			])
		}).put().done(_.bind(function () {
			this.set('lockedOn', null);
			callback(true);
		}, this)).fail(function () {
			callback(false);
		});
	},
	beforeSave: function () {
		if (this.groups) {
			this.set({
				groups: _.map(this.groups.models, function (group) {
					return {
						groupId: group.id,
						isDeleted: group.get('isDeleted')
					}
				})
			});
		}
	}
});

PJQ.models.users.UserFieldSetting = PJQ.models.BaseModel.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'user'
			},
			{
				endpoint: 'fields'
			}
		]);
	}
});

//Collections
PJQ.collections.users = {};

PJQ.collections.users.Users = PJQ.collections.contacts.Contacts.extend({
	model: PJQ.models.users.User,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users'
			}
		], [
			{
				parameter: 'isDetail',
				value: this.options.isDetail
			}
		])
	},
	getByUserType: function (userTypeId) {
		if (userTypeId == null) {
			return this.models;
		}

		return _.filter(this.models, function (user) {
			return userTypeId === user.get('userTypeId');
		})
	}
});

//Views
PJQ.views.users = {};

//Routes
PJQ.app.addRoutes({
	route: 'resetpassword/:guid',
	name: 'resetPassword',
	callback: function (guid) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'resetpassword',
					value: guid
				},
			])
		}).get().done(function (request) {
			if (request.error) {
				PJQ.app.router.signInNavigate();
				return;
			}

			if (PJQ.app.module === PJQ.constants.modules.APP) {
				new PJQ.views.auth.AppResetPassword({
					el: PJQ.app.$el,
					request: request,
					onReset: function () {
						new PJQ.views.BaseModal({
							header: "Password Reset Successfully",
							body: "Your password has been successfully reset.",
							isShowSecondaryButton: false,
							okButtonText: 'Go To Sign In',
							onOk: _.bind(function () {
								PJQ.app.router.signInNavigate();
							}, this)
						});
					}
				});
			}
			else {
				new PJQ.views.auth.ResetPasswordModal({
					request: request
				});
			}
		}).fail(function () {
			//todo: show error - this is an invalid request id
		});
	}
});

PJQ.models.users.UserCustomField = PJQ.models.customFields.CustomField.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users'
			},
			{
				endpoint: 'customfields',
				value: this.id
			}
		]);
	},
});

PJQ.collections.users.UserCustomFields = PJQ.collections.customFields.CustomFields.extend({
	model: PJQ.models.users.UserCustomField,
	options: {
		masterUserId: null
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users',
			},
			{
				endpoint: 'customfields'
			}
		], [
			{
				parameter: 'masterUserId',
				value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
			}
		]);
	}
});

PJQ.collections.users.UserFieldSettings = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.users.UserFieldSetting,
	endpoint: function () {
		let params;
		if (this.options.masterUserId > 0) {
			params = [
				{
					parameter: 'masterUserId',
					value: this.options.masterUserId
				}
			];
		} else {
			params = null;
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'users'
			},
			{
				endpoint: 'fields'
			}
		], params)
	}
});